import { defineStore } from 'pinia';
import {
  filter, sortBy,
} from 'lodash-es';
import chain from '@/lib/utils/chain';
import * as types from '@/lib/constants/store';

const useGlossaryStore = defineStore('studio-glossary', {
  state: () => ({
    terms: null,
    groups: null,
    selectedTerm: null,
  }),
  getters: {
    termsByLanguage() {
      return (code) => {
        const termsByCode = filter(this.terms, (term) => term.language_code === code);

        return sortBy(termsByCode, (term) => term?.title?.toLowerCase());
      };
    },
    hasGlossaryTerms() {
      return !!this.terms;
    },
  },
  actions: {
    [types.SET_GLOSSARY_DATA](glossaryData) {
      this.terms = glossaryData?.terms;
      this.selectedTerm = null;

      this.groups = chain(this.terms)
        .map((term) => term.groups)
        .flatten()
        .uniqBy((group) => group.id)
        .sortBy((group) => group.title)
        .value();
    },
    [types.SET_GLOSSARY_SELECTED_TERM](term) {
      this.selectedTerm = term;
    },
  },
});

export default useGlossaryStore;
